import { useSelector } from "react-redux"

export const useAgenceName = () => {
    const currentAgence = useSelector(state => state.agences?.currentAgence)
    // console.log({ currentAgence });
    return { nomAgence: currentAgence?.nomAgence }
}